import {
  DATAZAP_STAMPS,
} from '@/utils/constants/filters'

const getStamps = (stamps, business) => {
  if (!Array.isArray(stamps) || !business) return []

  return stamps.map((stamp) => {
    if (Object.values(DATAZAP_STAMPS).includes(stamp)) {
      return DATAZAP_STAMPS[business]
    }

    return stamp
  }).filter(Boolean)
}

const getRentalPeriod = (rentalPeriod, business) => (business === 'RENTAL' ? rentalPeriod : [])

const getPriceFields = (filters, business) => {
  const {
    priceMax, priceMin, rentalTotalPriceMax, rentalTotalPriceMin, rentTotalPrice,
  } = filters

  if (business === 'RENTAL') {
    return {
      priceMaxCondo: null,
      priceMinCondo: null,
    }
  }

  return {
    priceMax: (rentTotalPrice || rentalTotalPriceMax) ? rentalTotalPriceMax : priceMax,
    priceMin: (rentTotalPrice || rentalTotalPriceMin) ? rentalTotalPriceMin : priceMin,
    rentTotalPrice: null,
    rentalTotalPriceMax: null,
    rentalTotalPriceMin: null,
  }
}

const setFiltersByBusiness = ({
  stamps = [],
  rentalPeriod = [],
  ...filters
} = {}) => {
  if (!filters.business) return filters

  const { business } = filters

  filters.stamps = getStamps(stamps, business)
  filters.rentalPeriod = getRentalPeriod(rentalPeriod, business)

  const resetPriceFields = getPriceFields(filters, business)

  return { ...filters, ...resetPriceFields }
}

export {
  getStamps,
  getRentalPeriod,
  getPriceFields,
  setFiltersByBusiness,
}
